var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-profile-workspace"},[_c('div',{staticClass:"c-profile-workspace__details"},[_c('Workspace')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }